import { CUSTOM_FIELD_CATEGORIES, CustomFieldsQuery } from "@/Features";
import { EvidenceColumnDefinitions } from "../Definitions";
import { ColumnProps } from "@monolith-forensics/monolith-ui";
import CustomFieldCell from "@/components/Evidence/CustomFieldCell";
import { Evidence } from "../evidence.types";

export const useEvidenceColumnDefinitions = () => {
  const {
    data: customFields,
    isLoading,
    isFetched,
  } = CustomFieldsQuery.useGetCustomFields({
    category: CUSTOM_FIELD_CATEGORIES.EVIDENCE,
  });

  let columnDefinitions: ColumnProps[] = EvidenceColumnDefinitions;

  if (customFields) {
    columnDefinitions = [
      ...EvidenceColumnDefinitions,
      ...customFields?.data?.map((field) => ({
        dataField: `custom_field_${field.field_id}`,
        caption: field.field_name,
        visible: false,
        render: ({ rowData }: { rowData: Evidence }) => {
          // does this custom field have a value?
          if (
            !rowData.custom_attributes?.find(
              (attr) => attr.field_id === field.field_id
            )
          ) {
            return null;
          }
          return <CustomFieldCell rowData={rowData} field={field} />;
        },
      })),
    ];
  }

  return {
    columnDefinitions,
    customFields,
    isLoading,
    isFetched,
  };
};
